import {
  Button,
  BUTTON_VARIANTS,
  BUTTON_BACKGROUND_APPEARANCES
} from 'cdk-radial';
import { FormattedMessage, useIntl } from 'react-intl';
import { getUserRoleIsApOfficeManager } from 'pages/LandingPage/slice';
import { useAppSelector } from 'store/hooks';
import { StyledSelectedChecksSpan } from '../dialogs/PrintChecksDialog/styled';
import { CancelPaymentHeaderButton } from '../headerButtons';
import { labels } from './messages';
import { getSelectedVendors } from './slice';
import { StyledHeader } from './styled';
import { PrintChecksPageHeaderProps } from './types';

export const PrintChecksPageHeader = ({
  handleReviewAndPrintButton
}: PrintChecksPageHeaderProps): React.JSX.Element => {
  const intl = useIntl();
  const selectedPrintChecks = useAppSelector(getSelectedVendors);
  const isAuthorizedToCancelPayment = useAppSelector(
    getUserRoleIsApOfficeManager
  );

  return (
    <StyledHeader>
      {selectedPrintChecks?.length > 0 && (
        <StyledSelectedChecksSpan>{`${selectedPrintChecks?.length} ${
          selectedPrintChecks?.length > 1
            ? intl.formatMessage(labels.checksSelected)
            : intl.formatMessage(labels.checkSelected)
        }`}</StyledSelectedChecksSpan>
      )}
      {isAuthorizedToCancelPayment && <CancelPaymentHeaderButton />}
      <Button
        text={
          <FormattedMessage
            defaultMessage="Review and Print"
            description="Review and Print header button"
          />
        }
        dataTestId="review-and-print-button"
        variant={BUTTON_VARIANTS.PRIMARY}
        backgroundAppearance={BUTTON_BACKGROUND_APPEARANCES.LIGHT}
        onClick={() => handleReviewAndPrintButton()}
      />
    </StyledHeader>
  );
};
